<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：营业数据
        -->
    <div class="user">

     
      
      <div >

        <!--搜索表单-->
        <div class="common-seach-wrap"v-loading="loading">
          <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
            <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-4">
                <!-- 供应商下拉选择 -->
                <div class="relative"  v-if="isuse == 1">
                  <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                    <i class="fas fa-building"></i>
                    <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                    <i class="fas fa-chevron-down text-gray-400"></i>
                  </button>
                  <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                    <div class="py-2">
                      <div v-for="(item,index) in supply"  :key="index" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                        {{item.name}}
                      </div>
                    </div>
                  </div>
                </div>
                

              </div>


          
            </div>
      </div>
     
          
              <el-form-item label="起始时间">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker
                size="small"
                v-model="formInline.create_time"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-form-item>  

          <el-form-item label="产品名称"><el-input size="small" v-model="formInline.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
            
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>

            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="onExport">导出</el-button>
              
            </el-form-item>
          </el-form>
        </div>
    
        <!--内容-->
        <div class="product-content">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%"
            v-loading="loading" @selection-change="handleSelectionChange">
              <el-table-column type="product_name" prop="product_name" label="产品名称"  ></el-table-column>
              <el-table-column type="product_attr" prop="product_attr" label="规格" ></el-table-column>
              <!-- <el-table-column type="id" prop="id" label="分类" ></el-table-column> -->
              <el-table-column type="total_quantity" prop="total_quantity" label="数量"  ></el-table-column>
              <el-table-column type="unit_name" prop="unit_name" label="单位" ></el-table-column>
              <el-table-column type="total_cost" prop="total_cost" label="成本金额" ></el-table-column>
              <el-table-column type="total_amount" prop="total_amount" label="金额" ></el-table-column>
              <el-table-column type="gross_margin" prop="gross_margin" label="毛利率" ></el-table-column>
 
              <el-table-column type="rank" prop="create_timex" label="创建时间" ></el-table-column>
              
            </el-table>
          </div>
    
          <!--分页-->
          <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background :current-page="curPage"
            :page-sizes="[20, 100,500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
          </div>
        </div>
      </div>
  
   
    </div>
  </template>
  
  <script>
    import Warehouse_managementApi from '@/api/warehouse_management.js';

    import ReportApi from '@/api/report.js';
    import Supply_s from '@/components/select/warehouse';
    import qs from 'qs'
  export default {
    components: {
      Supply_s
    },
    data() {
      return {
  
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
           create_time: [],
           product_name:"",
 
    
        },
        warehouse:[],
        loading:false,

        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
 
        isuse:0,
       
      };
    },
    created() {
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
    this.getSupplys();
      this.getTableList()
    },
  
    methods: {
      getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.formInline.supply_id = supplier.supply_id
      },
      handleDateChange() {
        if (this.startDate && this.endDate) {
          this.refreshData();
        }
      },
      toggleWholesaleDropdown() {
        this.showWholesaleDropdown = !this.showWholesaleDropdown;
        this.showTimeDropdown = false;
        this.showStoreDropdown = false;
      },
      toggleStoreDropdown() {
        if (this.selectedWholesale) {
          this.showStoreDropdown = !this.showStoreDropdown;
          this.showWholesaleDropdown = false;
        }
      },
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/report/exportProduct?' + qs.stringify(this.formInline);
      },

      reasts(){
  
        this.formInline.warehouse_id = 0
        this.formInline.warehouse_kw_id = 0
        this.getTableList();
      },
       /*搜索查询*/
       onSubmit() {
        let self = this
        self.curPage = 1
        this.getTableList()
      },
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
       /*选择第几页*/
       handleCurrentChange(val) {
        this.curPage = val
        this.getTableList()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getTableList()
      },
      getTableList(){
        let self = this;
        let params = self.formInline;
      params.page = self.curPage;
      params.list_rows = self.pageSize;
      self.loading = true;
      ReportApi.product(params)
          .then((data) => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber =  data.data.list.total
            self.loading = false;
          })
          .catch((error) => {});
      }
  
    }
  };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/report/product.vue